const image1 = '/assets/static/4j4NmOof76wbbFbD3bww.webp'
const image4 = '/assets/static/NQi2sGbTGqyxahv07kE0.webp'
const image9 = '/assets/static/sFQyEKnsthhOTNIfXzih.webp'
const image14 = '/assets/static/qdIrLyPYJ7vnwKwsP6Hz.webp'
const image16 = '/assets/static/girl-riding-guy-porn.webp'
const image17 = '/assets/static/semen.webp'

const image1Anime = '/assets/static/image1Anime.webp'
const image2Anime = '/assets/static/image2Anime.webp'
const image4Anime = '/assets/static/image4Anime.webp'
const image10Anime = '/assets/static/image10Anime.webp'

const image1SuperSafe = '/assets/static/image1supersafe.webp'
const image2SuperSafe = '/assets/static/image2supersafe.webp'
const image3SuperSafe = '/assets/static/image3supersafe.webp'
const image4SuperSafe = '/assets/static/image4supersafe.webp'

export const staticVideosPorn = [
  {
    id: '4j4NmOof76wbbFbD3bww',
    title: 'Sexy brunette twerking, fireworks',
    imageUrl: '/assets/static/aiPornVideo/video1.mp4',
    description: 'Sexy brunette twerking, fireworks',
    likes: 3450,
    nsfw: false,
    date: '2023-06-17 05:53:56',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'cartoon, d, nude, naked, , , wrinkles',
    loras: 'Default',
    views: 54309,
    upscaled: true,
    prompt_ja:
      'アナログ スタイル、美しい女性の写真、庭で、ハイディテール、シャープ フォーカス、シネスティル t、(夜)、f、受賞歴、被写界深度が浅い、富士フイルム xt、mm、フィルム グレイン',
    prompt_de:
      'Analoger Stil, Foto einer schönen, vollen Frau, im Garten, hohe Detailgenauigkeit, scharfer Fokus, Cinestill T, (nachts), f, preisgekrönt, geringe Schärfentiefe, Fujifilm xt, mm, Filmkörnung',
    prompt_zh:
      '模拟风格，一个美丽的女人的照片，在花园里，高细节，锐利的焦点，cinestill t，（在晚上），f，获奖，浅景深，fujifilm xt，mm，胶片颗粒',
    prompt_es:
      'estilo analógico, fotografía de una hermosa mujer llena, en el jardín, gran detalle, enfoque nítido, cinestill t, (de noche), f, premiado, poca profundidad de campo, fujifilm xt, mm, grano de película',
    video: true,
    videoVersion: 2,
  },
  {
    id: 'mm7EawH0fkAIbP5UbYNU',
    title: 'Hot blonde in lingere, showing off her ass',
    imageUrl: '/assets/static/aiPornVideo/video6.mp4',
    description: 'Hot blonde in lingere, showing off her ass',
    likes: 165,
    nsfw: false,
    date: '2023-06-28 20:20:30',
    uid: '1w2X0knwJQQucF6DbPKq8rI7qW73',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt:
      'ugly, extra hands, poor quality, watermark, worst quality, cross eyed',
    loras: 'Cum in Mouth',
    views: 3189,
    upscaled: false,

    prompt_ja:
      '美しい女性の自撮り、トレジャー ハンター、ジャングル、ボタンを外したドレス シャツ、フェドーラ帽、サングラス、笑顔、ウインク、インディ ジョーンズ、トゥーム レイダー',
    prompt_de:
      'Selfie einer schönen Frau, Schatzsucherin, Dschungel, aufgeknöpftes Hemd, Fedora-Hut, Sonnenbrille, Lächeln, Zwinkern, Indiana Jones, Grabräuber',
    prompt_zh:
      '一个美丽女人的自拍照，宝藏猎人，丛林，解开衬衫，软呢帽，太阳镜，微笑，眨眼，印第安纳琼斯，古墓丽影',
    prompt_es:
      'selfie de una mujer hermosa, cazador de tesoros, selva, camisa de vestir desabrochada, sombrero fedora, gafas de sol, sonriente, guiño, indiana jones, tomb raider',
    video: true,
    videoVersion: 2,
  },

  {
    id: 's8raR2cAzOCqGEWMebW7',
    title: 'Sexy blonde in red bikini running, bouncing tits',
    imageUrl: '/assets/static/aiPornVideo/video2.mp4',
    description: 'Sexy blonde in red bikini running, bouncing tits',
    likes: 135,
    nsfw: true,
    date: '2023-05-19 18:38:55',
    uid: 'Ss7ivDyzCYQ3NbhiuJ74LvlT7mQ2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 6.5,
    negativePrompt:
      '((muscular)), six pack, ((open mouth)), broken lips, ugly face, broken legs, out of frame, EasyNegative, paintings, sketches, (worst quality:2), (low quality:2), (normal quality:2), lowres, normal quality, ((monochrome)), ((grayscale)), skin spots, acnes, skin blemishes, age spot, glans, mutated hands, (poorly drawn hands:1.5), blurry, (bad anatomy:1.21), extra limbs, lowers, bad hands, missing fingers, extra digit ,bad hands, missing fingers',
    loras: 'POV Doggystyle',
    views: 3879,
    prompt_ja:
      '(((リアルな品質)))、((4k))、((ハイレゾ))、(((素晴らしい品質:1.1)))、(((良い品質:1.1)))、(((ヤエミコ)) )、(((原神八重巫女)))、完璧なボディ、(草の上)、(((下乳)))、(((うつ伏せ:1.2)))、(((底なし)))、( ((肛門露出)))、(((猫露出)))、(((後ろから)))、(きつい肛門)、((きつい猫))、インニー猫、(((裸)))、スプレッド マンコ、(((巨大なお尻)))',
    prompt_de:
      '(((realistische Qualität))), ((4k)), ((hochauflösend)), (((erstaunliche Qualität:1.1))), (((gute Qualität:1.1))), (((Yae Miko)) ), (((Genshin Impact Yae Miko))), perfekter Körper, (auf Gras), (((Unterbrust))), (((auf dem Bauch liegend:1.2))), (((ohne Boden))), ( ((Anus entblößt))), (((Muschi entblößt))), (((von hinten))), (enger Anus), ((enge Muschi)), Innie-Muschi, (((nackt))), gespreizt Muschi, (((Riesenarsch)))',
    prompt_zh:
      '(((真实画质)))、((4k))、((高分辨率))、(((惊人画质：1.1)))、(((好画质：1.1)))、(((八重美子)) )、(((原神冲击八重巫女)))、完美身材、(草地上)、(((underboob)))、(((趴着:1.2)))、(((无底)))、( ((暴露肛门)))、(((暴露阴部)))、(((从后面)))、(紧肛门)、((紧阴部))、innie阴部、(((裸体)))、展开 猫，(((巨大的屁股)))',
    prompt_es:
      '(((calidad realista))), ((4k)), ((alta resolución)), (((calidad increíble: 1.1))), (((buena calidad: 1.1))), (((Yae Miko)) ), (((genshin impact Yae Miko))), cuerpo perfecto, (sobre la hierba), (((debajo del pecho))), (((acostado boca abajo: 1.2))), (((sin fondo))), ( ((ano expuesto))), (((coño expuesto))), (((por detrás))), (ano apretado), ((coño apretado)), coño innie, (((desnudo))), abierto coño, (((culo gigante)))',
    video: true,
    videoVersion: 2,
  },

  {
    id: '4nuiong4f9oidunsg904',
    title: 'Sexy asian sucking lollipop',
    imageUrl: '/assets/static/aiPornVideo/video3.mp4',
    description: 'Sexy asian sucking lollipop',
    likes: 135,
    nsfw: true,
    date: '2023-05-19 18:38:55',
    uid: 'Ss7ivDyzCYQ3NbhiuJ74LvlT7mQ2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 6.5,
    negativePrompt:
      '((muscular)), six pack, ((open mouth)), broken lips, ugly face, broken legs, out of frame, EasyNegative, paintings, sketches, (worst quality:2), (low quality:2), (normal quality:2), lowres, normal quality, ((monochrome)), ((grayscale)), skin spots, acnes, skin blemishes, age spot, glans, mutated hands, (poorly drawn hands:1.5), blurry, (bad anatomy:1.21), extra limbs, lowers, bad hands, missing fingers, extra digit ,bad hands, missing fingers',
    loras: 'POV Doggystyle',
    views: 3879,
    prompt_ja:
      '(((リアルな品質)))、((4k))、((ハイレゾ))、(((素晴らしい品質:1.1)))、(((良い品質:1.1)))、(((ヤエミコ)) )、(((原神八重巫女)))、完璧なボディ、(草の上)、(((下乳)))、(((うつ伏せ:1.2)))、(((底なし)))、( ((肛門露出)))、(((猫露出)))、(((後ろから)))、(きつい肛門)、((きつい猫))、インニー猫、(((裸)))、スプレッド マンコ、(((巨大なお尻)))',
    prompt_de:
      '(((realistische Qualität))), ((4k)), ((hochauflösend)), (((erstaunliche Qualität:1.1))), (((gute Qualität:1.1))), (((Yae Miko)) ), (((Genshin Impact Yae Miko))), perfekter Körper, (auf Gras), (((Unterbrust))), (((auf dem Bauch liegend:1.2))), (((ohne Boden))), ( ((Anus entblößt))), (((Muschi entblößt))), (((von hinten))), (enger Anus), ((enge Muschi)), Innie-Muschi, (((nackt))), gespreizt Muschi, (((Riesenarsch)))',
    prompt_zh:
      '(((真实画质)))、((4k))、((高分辨率))、(((惊人画质：1.1)))、(((好画质：1.1)))、(((八重美子)) )、(((原神冲击八重巫女)))、完美身材、(草地上)、(((underboob)))、(((趴着:1.2)))、(((无底)))、( ((暴露肛门)))、(((暴露阴部)))、(((从后面)))、(紧肛门)、((紧阴部))、innie阴部、(((裸体)))、展开 猫，(((巨大的屁股)))',
    prompt_es:
      '(((calidad realista))), ((4k)), ((alta resolución)), (((calidad increíble: 1.1))), (((buena calidad: 1.1))), (((Yae Miko)) ), (((genshin impact Yae Miko))), cuerpo perfecto, (sobre la hierba), (((debajo del pecho))), (((acostado boca abajo: 1.2))), (((sin fondo))), ( ((ano expuesto))), (((coño expuesto))), (((por detrás))), (ano apretado), ((coño apretado)), coño innie, (((desnudo))), abierto coño, (((culo gigante)))',
    video: true,
    videoVersion: 2,
  },

  {
    id: 'DVAZmI5A7MTQBbYqxAH8',
    title: 'Hot tiktok girl feeling her boobs, bra',
    imageUrl: '/assets/static/aiPornVideo/video4.mp4',
    description: 'Hot tiktok girl feeling her boobs, bra',
    likes: 252,
    nsfw: true,
    date: '2023-06-01 04:13:36',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'glasses, bad hands, naked',
    loras: 'Default',
    views: 5205,
    prompt_ja:
      'かわいい女子高生、学生服、夜の街で、長い髪、アヘガオ、マテリアル、d、素晴らしい照明、教室で、アートステーション、受賞歴のある、見事な、美的、深さ、シェーディング、非現実的なエンジン、ブレンダー',
    prompt_de:
      'süßes Schulmädchen, Schuluniform, nachts in der Stadt, langes Haar, Ahegao, Materpiece, d, tolle Beleuchtung, im Klassenzimmer, Artstation, preisgekrönt, atemberaubend, ästhetisch, Tiefe, Schattierung, unwirklicher Motor, Mixer',
    prompt_zh:
      '可爱的女学生, 校服, 夜晚的城市, 长发, ahegao, materpiece, d, 惊人的灯光, 在教室里, artstation, 获奖, 令人惊叹的, 审美的, 深度, 阴影, 虚幻引擎, 搅拌机',
    prompt_es:
      'linda colegiala, uniforme escolar, en la ciudad de noche, pelo largo, ahegao, obra maestra, re, iluminación increíble, en el aula, estación de arte, premiado, maravilloso, estético, profundidad, sombreado, motor irreal, licuadora',
    video: true,
    videoVersion: 2,
  },

  {
    id: '0WATu61C7YdnEfjrG0YU',
    title: 'Latina with big tits running in the rain',
    imageUrl: '/assets/static/aiPornVideo/video5.mp4',
    description:
      'Latina with big tits running in the rain, aesthetic, depth, shading, unreal engine, blender',
    likes: 252,
    nsfw: true,
    date: '2023-06-01 04:13:36',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'glasses, bad hands, naked',
    loras: 'Default',
    views: 5205,
    prompt_ja:
      'かわいい女子高生、学生服、夜の街で、長い髪、アヘガオ、マテリアル、d、素晴らしい照明、教室で、アートステーション、受賞歴のある、見事な、美的、深さ、シェーディング、非現実的なエンジン、ブレンダー',
    prompt_de:
      'süßes Schulmädchen, Schuluniform, nachts in der Stadt, langes Haar, Ahegao, Materpiece, d, tolle Beleuchtung, im Klassenzimmer, Artstation, preisgekrönt, atemberaubend, ästhetisch, Tiefe, Schattierung, unwirklicher Motor, Mixer',
    prompt_zh:
      '可爱的女学生, 校服, 夜晚的城市, 长发, ahegao, materpiece, d, 惊人的灯光, 在教室里, artstation, 获奖, 令人惊叹的, 审美的, 深度, 阴影, 虚幻引擎, 搅拌机',
    prompt_es:
      'linda colegiala, uniforme escolar, en la ciudad de noche, pelo largo, ahegao, obra maestra, re, iluminación increíble, en el aula, estación de arte, premiado, maravilloso, estético, profundidad, sombreado, motor irreal, licuadora',
    video: true,
    videoVersion: 2,
  },
]

export const staticImages = [
  {
    id: '4j4NmOof76wbbFbD3bww',
    title:
      'analog style, photograph of a beautiful ful woman, in garden, high detail, sharp focus, cinestill t, (at night), f, award winning, shallow depth of field, fujifilm xt, mm, film grain',
    imageUrl: image1,
    description:
      'analog style, photograph of a beautiful ful woman, in garden, high detail, sharp focus, cinestill t, (at night), f, award winning, shallow depth of field, fujifilm xt, mm, film grain',
    likes: 3450,
    nsfw: false,
    date: '2023-06-17 05:53:56',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'cartoon, d, nude, naked, , , wrinkles',
    loras: 'Default',
    views: 54309,
    upscaled: true,
    prompt_ja:
      'アナログ スタイル、美しい女性の写真、庭で、ハイディテール、シャープ フォーカス、シネスティル t、(夜)、f、受賞歴、被写界深度が浅い、富士フイルム xt、mm、フィルム グレイン',
    prompt_de:
      'Analoger Stil, Foto einer schönen, vollen Frau, im Garten, hohe Detailgenauigkeit, scharfer Fokus, Cinestill T, (nachts), f, preisgekrönt, geringe Schärfentiefe, Fujifilm xt, mm, Filmkörnung',
    prompt_zh:
      '模拟风格，一个美丽的女人的照片，在花园里，高细节，锐利的焦点，cinestill t，（在晚上），f，获奖，浅景深，fujifilm xt，mm，胶片颗粒',
    prompt_es:
      'estilo analógico, fotografía de una hermosa mujer llena, en el jardín, gran detalle, enfoque nítido, cinestill t, (de noche), f, premiado, poca profundidad de campo, fujifilm xt, mm, grano de película',
  },
  {
    id: 'w6f0YDGANkRMRIuqPm5u',
    title:
      'full body photo of tall and busty blonde, ((((incredibly tall)))) ((sexy)) ((((gigantic breasts)))) blonde pornstar, nude',
    imageUrl: image16,
    description:
      'full body photo of tall and busty blonde, ((((incredibly tall)))) ((sexy)) ((((gigantic breasts)))) blonde pornstar, nude',
    likes: 276,
    nsfw: true,
    date: '2023-06-17 06:31:07',
    uid: '1hYPp4ie9ZWfdVMauGpb',
    model: 'Photo XL',
    width: 512,
    height: 768,
    creativity: 6.5,
    negativePrompt: '',
    loras: 'Default',
    views: 12567,
    upscaled: false,
    prompt_ja:
      '背の高い巨乳のブロンドの全身写真、((((とても背が高い)))) ((セクシー)) ((((巨大な胸)))) ブロンドのポルノスター、ヌード',
    prompt_de:
      'Ganzkörperfoto einer großen und vollbusigen Blondine, ((((unglaublich groß)))) ((sexy)) ((((riesige Brüste)))) blonde Pornodarstellerin, nackt',
    prompt_zh:
      '高个子丰满金发女郎的全身照片，((((非常高)))) ((性感)) ((((巨大的乳房)))) 金发色情明星，裸体',
    prompt_es:
      'foto de cuerpo completo de rubia alta y tetona, ((((increíblemente alta)))) ((sexy)) ((((pechos gigantes)))) estrella porno rubia, desnuda',
  },
  {
    id: 'pwfg9rlgfJMVYXipPNJO',
    title:
      'beautiful korean, kpop idol, beautiful breast, stage, live audience',
    imageUrl: '/assets/static/aiPornVideo/video8.mp4',
    description:
      'beautiful korean, kpop idol, beautiful breast, stage, live audience',
    likes: 345,
    nsfw: true,
    date: '2025-02-25 15:23:55',
    uid: 'Ss7ivDyzCYQ3NbhiuJ74LvlT7mQ2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 6.5,
    loras: 'Missionary',
    views: 3342,
    prompt_ja: '美しい韓国人、K-POPアイドル、美しい胸、ステージ、ライブ観客',
    prompt_de:
      'schöne Koreanerin, K-Pop-Idol, schöne Brust, Bühne, Live-Publikum',
    prompt_zh: '美丽的韩国人，K-POP偶像，美丽的胸部，舞台，现场观众',
    prompt_es:
      'hermosa coreana, ídolo del k-pop, hermoso pecho, escenario, público en vivo',
    video: true,
    videoVersion: 2,
  },
  {
    id: 'hfsoih3890n',
    title:
      'One piece bikini, brown hair, brown eyes, freckles, headband, college, massive breast, walking at a beach, blue sea, pov selfie, smiling, charming',
    imageUrl: '/assets/static/aiPornVideo/video5.mp4',
    description:
      'One piece bikini, brown hair, brown eyes, freckles, headband, college, massive breast, walking at a beach, blue sea, pov selfie, smiling, charming',
    likes: 345,
    nsfw: true,
    date: '2025-02-25 15:23:55',
    uid: 'Ss7ivDyzCYQ3NbhiuJ74LvlT7mQ2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 6.5,
    loras: 'Holding Boobs',
    views: 3342,
    prompt_ja:
      'ワンピース水着、茶色の髪、茶色の目、そばかす、ヘアバンド、大学生、巨大な胸、ビーチを歩く、青い海、自撮り、笑顔、魅力的',
    prompt_de:
      'Einteiler Bikini, braunes Haar, braune Augen, Sommersprossen, Stirnband, College, riesige Brüste, am Strand spazieren, blaues Meer, POV-Selfie, lächelnd, charmant',
    prompt_zh:
      '连体比基尼，棕色头发，棕色眼睛，雀斑，发带，大学，巨大胸部，在海滩上行走，蓝色大海，自拍视角，微笑，迷人',
    prompt_es:
      'bikini de una pieza, pelo castaño, ojos marrones, pecas, cinta para el pelo, universidad, pechos enormes, caminando en la playa, mar azul, selfie pov, sonriente, encantadora',
    video: true,
    videoVersion: 2,
  },

  {
    id: 'hEisphW7hsIcjWj0wsyn',
    title:
      'sexy cheerleader, college, university campus, massive tits, outside at the school campus, lying down grass, pov selfie, adult',
    imageUrl: '/assets/static/aiPornVideo/video12.mp4',
    description:
      'sexy cheerleader, college, university campus, massive tits, outside at the school campus, lying down grass, pov selfie, adult',
    likes: 135,
    nsfw: true,
    date: '2023-05-19 18:38:55',
    uid: 'Ss7ivDyzCYQ3NbhiuJ74LvlT7mQ2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 6.5,
    negativePrompt:
      '((muscular)), six pack, ((open mouth)), broken lips, ugly face, broken legs, out of frame, EasyNegative, paintings, sketches, (worst quality:2), (low quality:2), (normal quality:2), lowres, normal quality, ((monochrome)), ((grayscale)), skin spots, acnes, skin blemishes, age spot, glans, mutated hands, (poorly drawn hands:1.5), blurry, (bad anatomy:1.21), extra limbs, lowers, bad hands, missing fingers, extra digit ,bad hands, missing fingers',
    loras: 'POV REVERSE Cowgirl Position',
    views: 3879,
    prompt_ja:
      'セクシーなチアリーダー、大学、大学キャンパス、巨大な胸、学校のキャンパスの外、芝生に寝転がる、自撮り、大人',
    prompt_de:
      'sexy Cheerleaderin, College, Universitätscampus, riesige Brüste, draußen auf dem Schulcampus, im Gras liegend, POV-Selfie, erwachsen',
    prompt_zh:
      '性感啦啦队员，大学，大学校园，巨大胸部，在学校校园外，躺在草地上，自拍视角，成人',
    prompt_es:
      'porrista sexy, universidad, campus universitario, tetas enormes, fuera en el campus de la escuela, acostada en el césped, selfie pov, adulta',
    video: true,
    videoVersion: 2,
  },
  {
    id: 'sFQyEKnsthhOTNIfXzih',
    title:
      'Slender blonde, wet pussy, nice jewelry, stunning eyes, small breast, gorgeous lighting, slim face, gleeful, happy eyes, full body, scenic background ',
    imageUrl: image9,
    description:
      'Slender blonde, wet pussy, nice jewelry, stunning eyes, small breast, gorgeous lighting, slim face, gleeful, happy eyes, full body, scenic background ',
    likes: 177,
    nsfw: true,
    date: '2023-05-22 19:17:25',
    uid: 'JaNVJ2vEsPVd9Z9eLuhoCSm8u4c2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 6.5,
    negativePrompt: '',
    loras: 'Cum in Mouth',
    views: 5088,
    prompt_ja:
      'アナログ スタイル、胸を持つ美しいかわいいアジアの女子大生モデルの写真、薄く、フィットし、平らなお腹、かわいい、裸、ベッドに横たわって恋人を待っている、高い詳細を提示、鋭い焦点、全身、波状でふわふわの縮れた短い髪、 魅惑的な笑顔、美しくはっきりとした頬骨と顎のライン、完璧な顔立ち、シネスティル t、f、受賞歴のある、浅い被写界深度、富士フイルム xt、mm、フィルム グレイン',
    prompt_de:
      'Analoger Stil, Foto eines wunderschönen, süßen asiatischen College-Mädchenmodells mit Brüsten, dünn, fit, flachem Bauch, süß, nackt, im Bett liegend und auf den Liebhaber wartend, mit hoher Detailgenauigkeit, scharfer Fokus, Ganzkörper, welliges und flauschiges, gekräuseltes kurzes Haar, verführerisches Lächeln, schöne, gut definierte Wangenknochen und Kieferlinie, perfekte Gesichtszüge, Cinestill T, F, preisgekrönt, geringe Schärfentiefe, Fujifilm xt, mm, Filmkörnung',
    prompt_zh:
      '模拟风格，一个美丽可爱的亚洲女大学生模型与乳房的照片，瘦，适合，平坦的肚子，可爱，裸体，躺在床上等待情人，呈现高细节，锐利的焦点，全身，波浪状和蓬松的卷曲短发， 微笑诱人，美丽轮廓分明的颧骨和下巴线条，完美的五官，cinestill t，f，屡获殊荣，浅景深，fujifilm xt，mm，胶片颗粒',
    prompt_es:
      'estilo analógico, fotografía de una hermosa y linda modelo universitaria asiática con senos, delgada, en forma, estómago plano, linda, desnuda, acostada en la cama esperando a su amante, presentando gran detalle, enfoque nítido, cuerpo completo, cabello corto rizado ondulado y esponjoso, sonrisa seductora, hermosos pómulos y línea de la mandíbula bien definidos, rasgos perfectos, cinestill t, f, premiado, poca profundidad de campo, fujifilm xt, mm, grano de película',
  },

  {
    id: 'qdIrLyPYJ7vnwKwsP6Hz',
    title:
      'partially nude, shy, girl, massive tits, spread legs, bra, cute hair, girl, orgasiming, flirt, black hair, horny, masturbating, ahegao, creampie, (((prostitute)))',
    imageUrl: image14,
    description:
      'partially nude, shy, girl, massive tits, spread legs, bra, cute hair, girl, orgasiming, flirt, black hair, horny, masturbating, ahegao, creampie, (((prostitute)))',
    likes: 138,
    nsfw: true,
    date: '2023-06-22 18:26:04',
    uid: 'dvMQGOoNCnZedmpWqYsztZ7s6Ku1',
    model: 'Hyperanime',
    width: 512,
    height: 768,
    creativity: 8.5,
    negativePrompt:
      'ugly, small breasts, big body, big face, big handy, big legs, big arms, big feeds, big ass,',
    loras: 'After Sex',
    views: 3540,
    upscaled: false,
    prompt_ja:
      '部分的にヌード、恥ずかしがり屋、女の子、巨大なおっぱい、開脚、ブラジャー、かわいい髪、女の子、オーガズム、浮気、黒髪、角質、自慰行為、アヘ顔、中出し、(((売春婦)))',
    prompt_de:
      'teilweise nackt, schüchtern, Mädchen, riesige Titten, Beine spreizen, BH, süße Haare, Mädchen, Orgasmus, Flirt, schwarze Haare, geil, masturbieren, Ahegao, Creampie, (((Prostituierte)))',
    prompt_zh:
      '部分裸体、害羞、女孩、巨乳、张开双腿、胸罩、可爱的头发、女孩、性高潮、调情、黑发、饥渴、自慰、ahegao、体内射精、（（（妓女）））',
    prompt_es:
      'parcialmente desnudo, tímido, chica, tetas enormes, piernas abiertas, sostén, lindo cabello, chica, orgasmo, coquetear, cabello negro, cachondo, masturbarse, ahegao, creampie, (((prostituta)))',
  },
  {
    id: '1cJTS0h8M4cAl8FlZPw6',
    title:
      'gorgeous redhead with blonde highlights, cutout shorts, underboob tanktop, teasing thong straps',
    imageUrl: image17,
    description:
      'gorgeous redhead with blonde highlights, cutout shorts, underboob tanktop, teasing thong straps',
    likes: 252,
    nsfw: true,
    date: '2023-06-01 04:13:36',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Hyperreal XL+',
    width: 512,
    height: 768,
    creativity: 4.5,
    loras: 'Default',
    views: 5205,
    prompt_ja:
      '金髪のハイライトが入った魅力的な赤毛、カットアウトショーツ、アンダーブーブタンクトップ、誘惑的なTバックのストラップ',
    prompt_de:
      'wunderschöne Rothaarige mit blonden Strähnen, geschnittene Shorts, Underboob-Tanktop, verführerische Tanga-Träger',
    prompt_zh:
      '带有金色挑染的迷人红发女郎，镂空短裤，露出下胸的背心，诱人的丁字裤带',
    prompt_es:
      'pelirroja hermosa con mechas rubias, shorts recortados, camiseta que muestra el bajo pecho, tirantes de tanga provocativos',
  },
  {
    id: 'wuiMXSzMNc12EMu6TOrA',
    title:
      'blonde, at the club, glitter makeup, spy clothing, smiling, selfie, crowd cheg, tattoos, side view angle',
    imageUrl: '/assets/static/aiPornVideo/video13.mp4',
    description:
      'blonde, at the club, glitter makeup, spy clothing, smiling, selfie, crowd cheg, tattoos, side view angle',
    likes: 135,
    nsfw: true,
    date: '2023-05-19 18:38:55',
    uid: 'Ss7ivDyzCYQ3NbhiuJ74LvlT7mQ2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 6.5,
    negativePrompt:
      '((muscular)), six pack, ((open mouth)), broken lips, ugly face, broken legs, out of frame, EasyNegative, paintings, sketches, (worst quality:2), (low quality:2), (normal quality:2), lowres, normal quality, ((monochrome)), ((grayscale)), skin spots, acnes, skin blemishes, age spot, glans, mutated hands, (poorly drawn hands:1.5), blurry, (bad anatomy:1.21), extra limbs, lowers, bad hands, missing fingers, extra digit ,bad hands, missing fingers',
    loras: 'POV REVERSE Cowgirl Position',
    views: 3879,
    prompt_ja:
      'ブロンド、クラブにて、グリッターメイク、スパイ服、笑顔、自撮り、群衆、タトゥー、横からの視点',
    prompt_de:
      'Blonde, im Club, Glitzer-Make-up, Spionage-Kleidung, lächelnd, Selfie, Menschenmenge, Tattoos, Seitenansicht',
    prompt_zh:
      '金发女郎，在夜店，闪粉妆容，间谍装扮，微笑，自拍，人群，纹身，侧面视角',
    prompt_es:
      'rubia, en el club, maquillaje con brillos, ropa de espía, sonriente, selfie, multitud, tatuajes, vista lateral',
    video: true,
    videoVersion: 2,
  },
  {
    id: 'r63dRfiYDr2LfldzKM7R',
    title:
      'cave diver, cave diver outfit and helmet, oxygen mask, massive breast, in a dark cave, flashlight, pov selfie, floating, air bubbles',
    imageUrl: '/assets/static/video8.mp4',
    description:
      'cave diver, cave diver outfit and helmet, oxygen mask, massive breast, in a dark cave, flashlight, pov selfie, floating, air bubbles',
    likes: 135,
    nsfw: true,
    date: '2023-05-19 18:38:55',
    uid: 'Ss7ivDyzCYQ3NbhiuJ74LvlT7mQ2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 6.5,
    negativePrompt:
      '((muscular)), six pack, ((open mouth)), broken lips, ugly face, broken legs, out of frame, EasyNegative, paintings, sketches, (worst quality:2), (low quality:2), (normal quality:2), lowres, normal quality, ((monochrome)), ((grayscale)), skin spots, acnes, skin blemishes, age spot, glans, mutated hands, (poorly drawn hands:1.5), blurry, (bad anatomy:1.21), extra limbs, lowers, bad hands, missing fingers, extra digit ,bad hands, missing fingers',
    loras: 'POV REVERSE Cowgirl Position',
    views: 3879,
    prompt_ja:
      'ケイブダイバー、ケイブダイバーの装備とヘルメット、酸素マスク、巨大な胸、暗い洞窟内、懐中電灯、自撮り、浮遊、空気の泡',
    prompt_de:
      'Höhlentaucher, Höhlentaucherausrüstung und Helm, Sauerstoffmaske, massive Brüste, in einer dunklen Höhle, Taschenlampe, POV-Selfie, schwebend, Luftblasen',
    prompt_zh:
      '洞穴潜水员，洞穴潜水装备和头盔，氧气面罩，巨大胸部，在黑暗洞穴中，手电筒，自拍视角，漂浮，气泡',
    prompt_es:
      'buzo de cuevas, traje y casco de buzo de cuevas, máscara de oxígeno, pecho masivo, en una cueva oscura, linterna, selfie pov, flotando, burbujas de aire',
    video: true,
    videoVersion: 2,
  },
]

export const staticImagesSuperSafe = [
  {
    id: 'NQi2sGbTGqyxahv07kE0',
    title:
      'cute school girl, school uniform, in city at night, long hair, ahegao, materpiece, d, amazing lighting, in classroom, artstation, award winning, stunning, aesthetic, depth, shading, unreal engine, blender',
    imageUrl: image4,
    description:
      'ccute school girl, school uniform, in city at night, long hair, ahegao, materpiece, d, amazing lighting, in classroom, artstation, award winning, stunning, aesthetic, depth, shading, unreal engine, blender',
    likes: 252,
    nsfw: false,
    date: '2023-06-01 04:13:36',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Anime',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'glasses, bad hands, naked',
    loras: 'Default',
    views: 5205,
    prompt_ja:
      'かわいい女子高生、学生服、夜の街で、長い髪、アヘガオ、マテリアル、d、素晴らしい照明、教室で、アートステーション、受賞歴のある、見事な、美的、深さ、シェーディング、非現実的なエンジン、ブレンダー',
    prompt_de:
      'süßes Schulmädchen, Schuluniform, nachts in der Stadt, langes Haar, Ahegao, Materpiece, d, tolle Beleuchtung, im Klassenzimmer, Artstation, preisgekrönt, atemberaubend, ästhetisch, Tiefe, Schattierung, unwirklicher Motor, Mixer',
    prompt_zh:
      '可爱的女学生, 校服, 夜晚的城市, 长发, ahegao, materpiece, d, 惊人的灯光, 在教室里, artstation, 获奖, 令人惊叹的, 审美的, 深度, 阴影, 虚幻引擎, 搅拌机',
    prompt_es:
      'linda colegiala, uniforme escolar, en la ciudad de noche, pelo largo, ahegao, obra maestra, re, iluminación increíble, en el aula, estación de arte, premiado, maravilloso, estético, profundidad, sombreado, motor irreal, licuadora',
  },
  {
    id: 'NQi2sGbTGqyxahv07kE0',
    title: '(inside garage, beautifull dusty car)',
    imageUrl: image1SuperSafe,
    description: '(inside garage, beautifull dusty car)',
    likes: 252,
    nsfw: false,
    date: '2023-06-01 04:13:36',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'glasses, bad hands, naked',
    loras: 'Default',
    views: 5205,
    prompt_ja:
      'かわいい女子高生、学生服、夜の街で、長い髪、アヘガオ、マテリアル、d、素晴らしい照明、教室で、アートステーション、受賞歴のある、見事な、美的、深さ、シェーディング、非現実的なエンジン、ブレンダー',
    prompt_de:
      'süßes Schulmädchen, Schuluniform, nachts in der Stadt, langes Haar, Ahegao, Materpiece, d, tolle Beleuchtung, im Klassenzimmer, Artstation, preisgekrönt, atemberaubend, ästhetisch, Tiefe, Schattierung, unwirklicher Motor, Mixer',
    prompt_zh:
      '可爱的女学生, 校服, 夜晚的城市, 长发, ahegao, materpiece, d, 惊人的灯光, 在教室里, artstation, 获奖, 令人惊叹的, 审美的, 深度, 阴影, 虚幻引擎, 搅拌机',
    prompt_es:
      'linda colegiala, uniforme escolar, en la ciudad de noche, pelo largo, ahegao, obra maestra, re, iluminación increíble, en el aula, estación de arte, premiado, maravilloso, estético, profundidad, sombreado, motor irreal, licuadora',
  },
  {
    id: 'NQi2sGbTGqyxahv07kE0',
    title: 'korean, in van, close up',
    imageUrl: image2SuperSafe,
    description: 'korean, in van, close up',
    likes: 252,
    nsfw: false,
    date: '2023-06-01 04:13:36',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'K-Pop',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'glasses, bad hands, naked',
    loras: 'Default',
    views: 5205,
    prompt_ja:
      'かわいい女子高生、学生服、夜の街で、長い髪、アヘガオ、マテリアル、d、素晴らしい照明、教室で、アートステーション、受賞歴のある、見事な、美的、深さ、シェーディング、非現実的なエンジン、ブレンダー',
    prompt_de:
      'süßes Schulmädchen, Schuluniform, nachts in der Stadt, langes Haar, Ahegao, Materpiece, d, tolle Beleuchtung, im Klassenzimmer, Artstation, preisgekrönt, atemberaubend, ästhetisch, Tiefe, Schattierung, unwirklicher Motor, Mixer',
    prompt_zh:
      '可爱的女学生, 校服, 夜晚的城市, 长发, ahegao, materpiece, d, 惊人的灯光, 在教室里, artstation, 获奖, 令人惊叹的, 审美的, 深度, 阴影, 虚幻引擎, 搅拌机',
    prompt_es:
      'linda colegiala, uniforme escolar, en la ciudad de noche, pelo largo, ahegao, obra maestra, re, iluminación increíble, en el aula, estación de arte, premiado, maravilloso, estético, profundidad, sombreado, motor irreal, licuadora',
  },
  {
    id: 'NQi2sGbTGqyxahv07kE0',
    title:
      'alien and surreal hall in an alien city, (orange glowing light from within the walls), ((slender alien close portrait)), long face, long legs, long body, close portrait    ',

    imageUrl: image3SuperSafe,
    description:
      'alien and surreal hall in an alien city, (orange glowing light from within the walls), ((slender alien close portrait)), long face, long legs, long body, close portrait    ',

    likes: 252,
    nsfw: false,
    date: '2023-06-01 04:13:36',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Hyperreal',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'glasses, bad hands, naked',
    loras: 'Default',
    views: 5205,
    prompt_ja:
      'かわいい女子高生、学生服、夜の街で、長い髪、アヘガオ、マテリアル、d、素晴らしい照明、教室で、アートステーション、受賞歴のある、見事な、美的、深さ、シェーディング、非現実的なエンジン、ブレンダー',
    prompt_de:
      'süßes Schulmädchen, Schuluniform, nachts in der Stadt, langes Haar, Ahegao, Materpiece, d, tolle Beleuchtung, im Klassenzimmer, Artstation, preisgekrönt, atemberaubend, ästhetisch, Tiefe, Schattierung, unwirklicher Motor, Mixer',
    prompt_zh:
      '可爱的女学生, 校服, 夜晚的城市, 长发, ahegao, materpiece, d, 惊人的灯光, 在教室里, artstation, 获奖, 令人惊叹的, 审美的, 深度, 阴影, 虚幻引擎, 搅拌机',
    prompt_es:
      'linda colegiala, uniforme escolar, en la ciudad de noche, pelo largo, ahegao, obra maestra, re, iluminación increíble, en el aula, estación de arte, premiado, maravilloso, estético, profundidad, sombreado, motor irreal, licuadora',
  },
  {
    id: 'NQi2sGbTGqyxahv07kE0',
    title: 'mulan, (green full ancient chinese armour), ancient china',
    imageUrl: image4SuperSafe,
    description: 'mulan, (green full ancient chinese armour), ancient china',
    likes: 252,
    nsfw: false,
    date: '2023-06-01 04:13:36',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Anime XL',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'glasses, bad hands, naked',
    loras: 'Default',
    views: 5205,
    prompt_ja:
      'かわいい女子高生、学生服、夜の街で、長い髪、アヘガオ、マテリアル、d、素晴らしい照明、教室で、アートステーション、受賞歴のある、見事な、美的、深さ、シェーディング、非現実的なエンジン、ブレンダー',
    prompt_de:
      'süßes Schulmädchen, Schuluniform, nachts in der Stadt, langes Haar, Ahegao, Materpiece, d, tolle Beleuchtung, im Klassenzimmer, Artstation, preisgekrönt, atemberaubend, ästhetisch, Tiefe, Schattierung, unwirklicher Motor, Mixer',
    prompt_zh:
      '可爱的女学生, 校服, 夜晚的城市, 长发, ahegao, materpiece, d, 惊人的灯光, 在教室里, artstation, 获奖, 令人惊叹的, 审美的, 深度, 阴影, 虚幻引擎, 搅拌机',
    prompt_es:
      'linda colegiala, uniforme escolar, en la ciudad de noche, pelo largo, ahegao, obra maestra, re, iluminación increíble, en el aula, estación de arte, premiado, maravilloso, estético, profundidad, sombreado, motor irreal, licuadora',
  },
]

export const staticImagesSafe = [
  {
    id: 'kYFpdfn3QuF6j4j0asBJ',
    title:
      'cute school girl, school uniform, in city at night, long hair, ahegao, materpiece, d, amazing lighting, in classroom, artstation, award winning, stunning, aesthetic, depth, shading, unreal engine, blender',
    imageUrl: '/assets/static/madeWithPromptchan/twerk.mp4',
    description:
      'cute school girl, school uniform, in city at night, long hair, ahegao, materpiece, d, amazing lighting, in classroom, artstation, award winning, stunning, aesthetic, depth, shading, unreal engine, blender',
    likes: 252,
    nsfw: false,
    date: '2023-06-01 04:13:36',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Anime',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'glasses, bad hands, naked',
    loras: 'Default',
    views: 5205,
    prompt_ja:
      'かわいい女子高生、学生服、夜の街で、長い髪、アヘガオ、マテリアル、d、素晴らしい照明、教室で、アートステーション、受賞歴のある、見事な、美的、深さ、シェーディング、非現実的なエンジン、ブレンダー',
    prompt_de:
      'süßes Schulmädchen, Schuluniform, nachts in der Stadt, langes Haar, Ahegao, Materpiece, d, tolle Beleuchtung, im Klassenzimmer, Artstation, preisgekrönt, atemberaubend, ästhetisch, Tiefe, Schattierung, unwirklicher Motor, Mixer',
    prompt_zh:
      '可爱的女学生, 校服, 夜晚的城市, 长发, ahegao, materpiece, d, 惊人的灯光, 在教室里, artstation, 获奖, 令人惊叹的, 审美的, 深度, 阴影, 虚幻引擎, 搅拌机',
    prompt_es:
      'linda colegiala, uniforme escolar, en la ciudad de noche, pelo largo, ahegao, obra maestra, re, iluminación increíble, en el aula, estación de arte, premiado, maravilloso, estético, profundidad, sombreado, motor irreal, licuadora',
    video: true,
    videoVersion: 4,
  },
  {
    id: 'uni9o3whf90f83jh0j',
    title: 'Sexy brunette twerking, fireworks',
    imageUrl: '/assets/static/madeWithPromptchan/twerk2.mp4',
    description: 'Sexy brunette twerking, fireworks',
    likes: 3450,
    nsfw: false,
    date: '2023-06-17 05:53:56',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'cartoon, d, nude, naked, , , wrinkles',
    loras: 'Default',
    views: 54309,
    upscaled: true,
    prompt_ja:
      'アナログ スタイル、美しい女性の写真、庭で、ハイディテール、シャープ フォーカス、シネスティル t、(夜)、f、受賞歴、被写界深度が浅い、富士フイルム xt、mm、フィルム グレイン',
    prompt_de:
      'Analoger Stil, Foto einer schönen, vollen Frau, im Garten, hohe Detailgenauigkeit, scharfer Fokus, Cinestill T, (nachts), f, preisgekrönt, geringe Schärfentiefe, Fujifilm xt, mm, Filmkörnung',
    prompt_zh:
      '模拟风格，一个美丽的女人的照片，在花园里，高细节，锐利的焦点，cinestill t，（在晚上），f，获奖，浅景深，fujifilm xt，mm，胶片颗粒',
    prompt_es:
      'estilo analógico, fotografía de una hermosa mujer llena, en el jardín, gran detalle, enfoque nítido, cinestill t, (de noche), f, premiado, poca profundidad de campo, fujifilm xt, mm, grano de película',
    video: true,
    videoVersion: 4,
  },
  {
    id: 'xRk21MIxaylVqPsfQ60y',
    title:
      'analog style, photograph of a beautiful ful woman, in garden, high detail, sharp focus, cinestill t, (at night), f, award winning, shallow depth of field, fujifilm xt, mm, film grain',
    imageUrl: '/assets/static/madeWithPromptchan/beach.webp',
    description:
      'analog style, photograph of a beautiful ful woman, in garden, high detail, sharp focus, cinestill t, (at night), f, award winning, shallow depth of field, fujifilm xt, mm, film grain',
    likes: 3450,
    nsfw: false,
    date: '2023-06-17 05:53:56',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'cartoon, d, nude, naked, , , wrinkles',
    loras: 'Default',
    views: 54309,
    upscaled: true,
    prompt_ja:
      'アナログ スタイル、美しい女性の写真、庭で、ハイディテール、シャープ フォーカス、シネスティル t、(夜)、f、受賞歴、被写界深度が浅い、富士フイルム xt、mm、フィルム グレイン',
    prompt_de:
      'Analoger Stil, Foto einer schönen, vollen Frau, im Garten, hohe Detailgenauigkeit, scharfer Fokus, Cinestill T, (nachts), f, preisgekrönt, geringe Schärfentiefe, Fujifilm xt, mm, Filmkörnung',
    prompt_zh:
      '模拟风格，一个美丽的女人的照片，在花园里，高细节，锐利的焦点，cinestill t，（在晚上），f，获奖，浅景深，fujifilm xt，mm，胶片颗粒',
    prompt_es:
      'estilo analógico, fotografía de una hermosa mujer llena, en el jardín, gran detalle, enfoque nítido, cinestill t, (de noche), f, premiado, poca profundidad de campo, fujifilm xt, mm, grano de película',
  },
  {
    id: 'IJJDnMsSqZ534w5rV51h',
    title: 'beautiful brunette',
    imageUrl: '/assets/static/madeWithPromptchan/render.mp4',
    description: 'beautiful brunette',
    likes: 258,
    nsfw: null,
    date: '2023-06-20 10:24:58',
    uid: '6mt7EocAjbhK5YkGDstri2LTLKe2',
    model: 'Real',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: '',
    loras: 'Default',
    views: 5412,
    upscaled: false,
    prompt_ja: 'ブロンド、胸、((ヨット上))',
    prompt_de: 'blond, Brüste, ((auf Yacht))',
    prompt_zh: '金发女郎，乳房，（（在游艇上））',
    prompt_es: 'rubia, pechos, ((en yate))',
    video: true,
    videoVersion: 4,
  },
]

export const staticImagesAnime = [
  {
    id: 'n90IMkle5XWH75p8e4s9',
    title: 'big breasts, face, body, in sexy pyjamas',
    imageUrl: image1Anime,
    description: 'big breasts, face, body, in sexy pyjamas',
    likes: 108,
    nsfw: false,
    date: '2023-06-14 05:53:56',
    uid: 'ATwFPKN5ZEXuIm46a1VFCehPxZW2',
    model: 'Anime',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'fat, ugly',
    loras: 'Breast Squeeze',
    views: 858,
    upscaled: true,
    prompt_ja: '大きな胸、顔、体、セクシーなパジャマを着て',
    prompt_de: 'große Brüste, Gesicht, Körper, in sexy Pyjamas',
    prompt_zh: '大乳房，脸，身体，穿着性感睡衣',
    prompt_es: 'pechos grandes, cara, cuerpo, en pijama sexy',
  },
  {
    id: 'oD1vWqBVAPPQAaMSUKlk',
    title: 'schoolgirl, (sitting fence), panty close up from behind',
    imageUrl: image2Anime,
    description: 'schoolgirl, (sitting fence), panty close up from behind',
    likes: 120,
    nsfw: false,
    date: '2023-06-07 06:31:07',
    uid: 'Q77SCKy6KtfejNxOeo2QRdkELSj2',
    model: 'Hyperanime',
    width: 512,
    height: 512,
    creativity: 6.5,
    negativePrompt: '',
    loras: 'Default',
    views: 1434,
    upscaled: false,
    prompt_ja: '女子高生、(フェンスに座って)、パンティを後ろからクローズアップ',
    prompt_de:
      'Schulmädchen, (sitzend am Zaun), Höschen in Nahaufnahme von hinten',
    prompt_zh: '女学生（坐在栅栏上），内裤从后面特写',
    prompt_es: 'colegiala, (cerca sentada), bragas de cerca por detrás',
  },
  {
    id: 'JGSlEjj13v4uAus825SW',
    title:
      'desert, bright sun, exhausted, sweaty, dark skin, blonde hair, ripped clothes',
    imageUrl: image4Anime,
    description:
      'desert, bright sun, exhausted, sweaty, dark skin, blonde hair, ripped clothes',
    likes: 168,
    nsfw: false,
    date: '2023-06-01 04:13:36',
    uid: 'Saqcs9LPlPZ8z46AVRdcQ57nedf2',
    model: 'Hyperanime',
    width: 512,
    height: 768,
    creativity: 4.5,
    negativePrompt: 'animal ears',
    loras: 'Default',
    views: 1929,
    upscaled: true,
    prompt_ja:
      '砂漠、明るい太陽、疲れきった、汗だく、黒い肌、ブロンドの髪、破れた服',
    prompt_de:
      'Wüste, strahlende Sonne, erschöpft, verschwitzt, dunkle Haut, blondes Haar, zerrissene Kleidung',
    prompt_zh: '沙漠、灿烂的阳光、疲惫、出汗、黑皮肤、金发、破烂的衣服',
    prompt_es:
      'desierto, sol brillante, exhausto, sudoroso, piel oscura, cabello rubio, ropa rasgada',
  },
  {
    id: 'w6f0YDGANkRMRIuqPm5u',
    title:
      'cute fit brunette girl, short hair,, gym, sweaty, highly detailed, masterpiece, professional photo, extreme details, high resolution, hdr',
    imageUrl: image10Anime,
    description:
      'cute fit brunette girl, short hair,, gym, sweaty, highly detailed, masterpiece, professional photo, extreme details, high resolution, hdr',
    likes: 183,
    nsfw: null,
    date: '2023-06-17 06:31:07',
    uid: '57qlmsb4JlTEpZmuooqlTgj1rLy2',
    model: 'Anime',
    width: 512,
    height: 768,
    creativity: 6.5,
    negativePrompt: '',
    loras: 'Default',
    views: 21111,
    upscaled: false,
    seed: '2031747153',
    reports: 15,
    prompt_ja:
      'キュートなフィットのブルネットの女の子、ショートヘア、ジム、汗だく、非常に詳細な、傑作、プロの写真、極端な詳細、高解像度、hdr',
    prompt_de:
      'süßes, fittes brünettes Mädchen, kurzes Haar, Fitnessstudio, verschwitzt, sehr detailliert, Meisterwerk, professionelles Foto, extreme Details, hohe Auflösung, HDR',
    prompt_zh:
      '可爱适合黑发女孩, 短发,, 健身房, 出汗, 非常详细, 杰作, 专业照片, 极端细节, 高分辨率, hdr',
    prompt_es:
      'linda chica morena en forma, cabello corto, gimnasio, sudoroso, muy detallado, obra maestra, fotografía profesional, detalles extremos, alta resolución, hdr',
  },
]

// Kept apart so the modules every page loads can import them without this file (plan step W2).
export { staticProfiles } from './staticProfiles'
export { sampleImagesCreate } from './sampleImagesCreate'
